module.exports = __webpack_public_path__ + "static/media/software-development.cb021b52.jpg";